import { rootRoute } from './root'
import { developerRoute } from './developer'
import { homeRoute } from './home'
import { settingsRoute } from './settings'
import { userManagementRoute } from './userManagement'
import { applicationsRoute } from './applications'
import { identitiesRoute } from './identities/route'
import { authProvidersRoute } from './authProviders'
import { apisRoute } from './apis'

export const tenantRoute = rootRoute.addChildren([
    homeRoute,
    userManagementRoute,
    settingsRoute,
    authProvidersRoute,
    apisRoute,
    developerRoute,
    applicationsRoute,
    identitiesRoute,
])
